export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12208.af3d4105.jpg";